import withAdminAndDesignerRole from './withAdminAndDesignerRole';
export default withAdminAndDesignerRole;
